module.exports = __webpack_public_path__ + "img/gift.09536741.png";